export default "__VITE_ASSET__BWWoj5Wc__"